<script setup lang="ts">

import {computed, onMounted, ref} from "vue";
import type {TokenEvent} from "@/models/token_event";
import router from "@/router";
import {useRoute} from "vue-router";
import {store} from "@/store";
import endpointsService from "@/services/endpointsService";
import {RouteNames} from "@/router/routeNames";

const route = useRoute();

const error = ref<boolean>(false);

let theChannelId = '';

onMounted(() => {
  window.addEventListener('electronSetup', event => {
    theChannelId = route.query.channelId as string;
    getAndSetToken(event);
  })
})

async function getAndSetToken(event: Event) {
  try {
    const tokenEvent = event as unknown as TokenEvent
    if (!tokenEvent.detail){
      return error.value = true;
    }
    // Set details in the store
    store.setDetails(tokenEvent.detail);
    // Set the endpoints
    endpointsService.setRegion(store.country.value);
    if (!theChannelId) {
      await router.push({name: RouteNames.Channels});
      return;
    }
    await router.push({name: RouteNames.Channel, params: {channelId: theChannelId}});
  } catch (e) {
    console.error(e);
    error.value = true;
  }
}

const messageText = computed(() => {
  return error.value ?
      'Something went wrong while fetching your details ...' :
      'Verifying your details ...';
})

</script>

<template>
  <div class="message-wrapper">
    <h1>{{ messageText }}</h1>
  </div>
</template>

<style scoped>

.message-wrapper {
  display: flex;
  justify-content: center;
}
</style>
